import i18n from '@/utils/i18n';
import React from 'react';
import { Checkbox } from '@/components/checkbox';
import {
  CHECKBOX_CONTAINER_SIZE,
  LIST_INDEX_WIDTH,
} from './order-guide-editable-row';
import { createStyles } from '@/contexts/theme-context';
import {
  DRAG_HANDLE_MARGIN,
  DRAG_HANDLE_WIDTH,
} from '@/components/sortable-list-types';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { PAR_INPUT_SIZE } from './par-level-input';
import { Text, View } from 'react-native';
import { useLayoutContext } from '@/contexts/layout-context';

interface Props {
  isSelectAllSelected: boolean;
  onSelectAll: () => void;
  partitionUUID: string;
}

export const OrderGuideEditorHeaderRow: React.FC<Props> = ({
  isSelectAllSelected,
  onSelectAll,
  partitionUUID,
}) => {
  const { isSmallLayout } = useLayoutContext();
  const [styles] = useStyles();

  return (
    <View
      style={[styles.base, isSmallLayout ? null : styles.baseLarge]}
      testID="order-guide-editor-header-row"
    >
      <View style={styles.item}>
        <Checkbox
          isSelected={isSelectAllSelected}
          onSelect={onSelectAll}
          style={styles.checkbox}
          trackingData={{
            name: 'edit_order_guide.select_all',
            properties: {
              partitionUUID,
            },
          }}
        />
        <Text style={[TYPOGRAPHY.small, styles.text]}>{i18n.t('item')}</Text>
      </View>
      <View style={styles.par}>
        <Text style={[TYPOGRAPHY.small, styles.text, styles.parText]}>
          {i18n.t('par')}
        </Text>
      </View>
    </View>
  );
};

const BASE_HORIZONTAL_PADDING = 16;

const useStyles = createStyles((theme) => ({
  base: {
    alignItems: 'center',
    backgroundColor: theme.colors.background,
    flexDirection: 'row',
    paddingHorizontal: BASE_HORIZONTAL_PADDING,
    paddingVertical: 8,
  },
  baseLarge: {
    paddingLeft: BASE_HORIZONTAL_PADDING + LIST_INDEX_WIDTH,
  },
  checkbox: {
    backgroundColor: theme.colors.background,
    paddingLeft: 0,
    paddingVertical: 0,
    width: CHECKBOX_CONTAINER_SIZE,
  },
  item: {
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
  },
  par: {
    marginRight: DRAG_HANDLE_MARGIN + DRAG_HANDLE_WIDTH,
    width: PAR_INPUT_SIZE,
  },
  parText: {
    textAlign: 'center',
  },
  text: {
    ...FONTS.primaryBold,
    color: theme.colors.inactiveText,
    textTransform: 'uppercase',
  },
}));
